export default __webpack_public_path__ + "static/media/pic1.894f9c55.png";